import ENV from './env';
import { QueryClient } from 'react-query';

export function debounce<T extends (...args: any[]) => any>(fn: T, wait = 0) {
  if (!wait) {
    return fn;
  }

  let timer: any = null;

  return (...args: any[]) => {
    if (timer) {
      clearTimeout(timer);
    }
    // 保存查询之后输入值
    timer = setTimeout(function () {
      fn.apply(null, args);
    }, wait);
  };
}

export const devLog = (key: string, ...info: any) => {
  // if (ENV.isDev) {
  //   console.log(`[${key}]`, ...info);
  // }
};

export const shorten = (str: string, start = 0, end = 0) => {
  const strLen = (str || '').length;
  if (!strLen || !start || start >= strLen || start + end >= strLen) return str;

  const startStr = str.substr(0, start);
  const endStr = end ? str.substr(-end) : '';

  return `${startStr}…${endStr}`;
};

export function withHttp(url: string, defaultProtocol = 'https') {
  var pattern = /^((http|https|ftp):\/\/)/;

  if (!pattern.test(url)) {
    url = `${defaultProtocol}://${url}`;
  }
  return url;
}

export const canRetryError = (err: any) => {
  return (
    // http code
    err?.status
      ? err.status >= 500
      : // typeError => cors error, network unstable
        err?.name === 'TypeError'
  );
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchInterval: false,
      retry: (failureCount, error) => {
        return !failureCount && canRetryError(error);
      },
      cacheTime: 1000,
      staleTime: 1000,
    },
  },
});
